import { IconDone } from '../../elements/Icon2';
import { useTranslation } from 'react-i18next';
import { langs } from "./assets/constants";


const getLang = (name) => {
    const index = name.indexOf('-');
    return index === -1 ? name : name.slice(0, index);
};

export const Language = ({ onClose }) => {
    const { t, i18n } = useTranslation();

    const currentLang =
        getLang(localStorage.getItem('i18nextLng')) || 'en';

    const handleLanguage = (name) => {
        i18n.changeLanguage(name);
        onClose();
    };

    return (
        <div
            onClick={onClose}
            className="w-full h-full absolute z-[70] bg-black/30 flex justify-center items-center"
        >
            <div
                onClick={(e) => e.stopPropagation()}
                className="
                          relative
                          xl:w-[896px] lg:w-[656px] md:w-[540px] sm:w-[516px] w-[272px]
                          xl:h-[466px] lg:h-[336px] md:h-[283px] sm:h-[265px] h-[336px]
                          rounded-[19px]
                          border-[4px]
                          border-[#7743BA]
                          bg-[#F8F4EA]
                          shadow-xl
                        "
            >
                <h2 className="
                               text-[#4B96C9]
                               xl:text-[36px] lg:text-[26px] md:text-[24px] text-[20px]
                               text-center
                               font-fredokaOne
                               mt-[10px]
                             ">
                    {t("languages")}
                </h2>

                <div className="overflow-y-auto h-[280px] sm:h-[205px] md:h-[220px] lg:h-[270px] xl:h-[380px]">
                    {Object.entries(langs).map(([key, value]) => (
                        <div
                            key={value}
                            onClick={() => handleLanguage(value)}
                            className={`
                                py-2 cursor-pointer border-b-2 border-[#EBEBEB]
                                text-[#4F9686] font-fredokaOne px-4 flex justify-between items-center
                                xl:text-[24px] lg:text-[20px] md:text-[16px] text-[16px]
                            `}
                        >
                            {key}

                            {currentLang === getLang(value) && (
                                <IconDone className="w-[18px] md:w-[24px]"/>
                            )}
                        </div>
                    ))}
                </div>

            </div>
        </div>
    );
};
